exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-main[data-v-164b4c8e]{padding:0 .32rem}.sub_t[data-v-164b4c8e]{font-size:.18rem;font-weight:bold}", ""]);

// exports
